//@helpers
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
//@actions
const signaturePatternActions = require('actions/signaturePattern');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const get = require('lodash/object/get');
// @ constants
const actionTypes = require('constants/actionTypes');
const {
    ACCOUNT_CHEQUEBOOK_NEW_LANGUAGE,
    ACCOUNT_CHEQUEBOOK_NEW_DOCUMENT_NUMBERS,
    ACCOUNT_CHEQUEBOOK_NEW_DOCUMENT_NUMBERS_NAME
} = require('constants/index');

const requestAdditionalChequebookInformationInProgress = accountId => ({
    type: actionTypes.SET_ACCOUNT_CHECKBOOK_INFO_REQUEST,
    payload: {
        accountId
    }
});

const requestAdditionalChequebookInformationSuccess = (data, accountId) => ({
    type: actionTypes.SET_ACCOUNT_CHECKBOOK_INFO_SUCCESS,
    payload: {
        accountId,
        data
    }
});

const requestAdditionalChequebookInformationFailure = error => ({
    type: actionTypes.SET_ACCOUNT_CHECKBOOK_INFO_FAILURE,
    payload: {
        error
    }
});

const requestAdditionalChequebookInformation = accountId => (dispatch, getState) => {
    const isAlreadyFetching = getState().accountChequebookAdditionalInformation.get('inProgress');
    const immAccount = getState().accounts.get('byId').get(accountId);

    if (!isAlreadyFetching && immAccount) {
        const requestData = {
            query: {
                producto: immAccount.get('product'),
                numeroContrato: immAccount.get('contractNumber')
            }
        };

        dispatch(requestAdditionalChequebookInformationInProgress(accountId));
        return APIGet({ dispatch, endpoint: 'accountChequebookChargeData', params: requestData })
            .then(response => {
                if (!!get(response, 'listaCondiciones.datoCondiciones[0]')) {
                    return dispatch(
                        requestAdditionalChequebookInformationSuccess(response, accountId)
                    );
                } else {
                    return dispatch(requestAdditionalChequebookInformationFailure(response.error));
                }
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(requestAdditionalChequebookInformationFailure(response.error));
                } else throw response;
            });
    }
};

const accountNewChequebookRequest = () => ({
    type: actionTypes.SET_ACCOUNT_NEW_CHECKBOOK_REQUEST
});

const accountNewChequebookSuccess = () => ({
    type: actionTypes.SET_ACCOUNT_NEW_CHECKBOOK_SUCCESS
});

const accountNewChequebookFailure = error => ({
    type: actionTypes.SET_ACCOUNT_NEW_CHECKBOOK_FAILURE,
    error
});

const clearAccountNewChequebook = response => ({
    type: actionTypes.SET_ACCOUNT_NEW_CHECKBOOK_INITIAL,
    payload: response
});

const requestNewChequebook = accountId => (dispatch, getState) => {
    const hasAdditionalInformation = getState().accountChequebookAdditionalInformation.get(
        'hasBeenFetched'
    );

    if (hasAdditionalInformation) {
        const immAccount = getState().accounts.get('byId').get(accountId);
        const additionalInformation = getState().accountChequebookAdditionalInformation.get(
            'additionalInformation'
        );

        const callback = (dispatch, getState, dataToken) => {
            const requestData = {
                query: {
                    cantidadDeDocumentos: ACCOUNT_CHEQUEBOOK_NEW_DOCUMENT_NUMBERS_NAME,
                    contratoNuevo: {
                        numerodecontrato: additionalInformation.get('contractNumber'),
                        producto: additionalInformation.get('product')
                    },
                    datosConexion: {
                        contrato: {
                            numerodecontrato: immAccount.get('contractNumber'),
                            producto: immAccount.get('product')
                        }
                    },
                    idioma: ACCOUNT_CHEQUEBOOK_NEW_LANGUAGE,
                    idiomaImpresion: ACCOUNT_CHEQUEBOOK_NEW_LANGUAGE,
                    indicadorAntefima: additionalInformation.get('preSignatureIndicator'),
                    indicadorPersonalizacion: additionalInformation.get('customisationIndicator'),
                    indicadorTipoDeDocumento: additionalInformation.get('documentTypeIndicator'),
                    indicadorTipoDestino: additionalInformation.get('documentTypeIndicator'),
                    indicadorTipoFormato: additionalInformation.get('formatTypeIndicator'),
                    moneda: additionalInformation.get('currency'),
                    monedaPeticion: additionalInformation.get('currency'),
                    numeroContrato: additionalInformation.get('contractNumber'),
                    numeroDeDocumentos: ACCOUNT_CHEQUEBOOK_NEW_DOCUMENT_NUMBERS,
                    producto: additionalInformation.get('product'),
                    secuencial: additionalInformation.get('secuencial'),
                    subtipoProducto: additionalInformation.get('productSubType'),
                    dataToken
                }
            };

            dispatch(accountNewChequebookRequest());
            return APIPost({
                dispatch,
                endpoint: 'accountCheques',
                url: apiURLBuilder.getURL('accountCheques'),
                params: requestData
            })
                .then(response => dispatch(accountNewChequebookSuccess(response)))
                .catch(error => dispatch(accountNewChequebookFailure(error)));
        };

        return new Promise(() => {
            signaturePatternActions.validateAndExecute(dispatch, getState, callback);
        });
    }
};

module.exports = {
    requestAdditionalChequebookInformation,
    requestNewChequebook,
    clearAccountNewChequebook
};
